<template>
    <v-menu bottom right>
        <template #activator="{on}">
            <v-btn
                icon
                v-on="on"
            >
                <v-icon large>
                    mdi-chevron-down
                </v-icon>
            </v-btn>
        </template>
        <v-list>
            <v-list-item
                @click="redirectToList('outdoorsSettingsOutdoorsLocalizations')"
            >
                <v-list-item-action>
                    <v-icon>
                        mdi-chevron-right-box
                    </v-icon>
                </v-list-item-action>
                <v-list-item-title>Lokalizacje</v-list-item-title>
            </v-list-item>
            <v-list-item
                @click="redirectToList('outdoorsSettingsOutdoorsTeams')"
            >
                <v-list-item-action>
                    <v-icon>
                        mdi-chevron-right-box
                    </v-icon>
                </v-list-item-action>
                <v-list-item-title>Ekipy</v-list-item-title>
            </v-list-item>
            <v-list-item
                @click="redirectToList('outdoorsSettingsOutdoorsContractors')"
            >
                <v-list-item-action>
                    <v-icon>
                        mdi-chevron-right-box
                    </v-icon>
                </v-list-item-action>
                <v-list-item-title>Zleceniobiorcy</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
import router from '@/router'
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'SelectMenu',
    methods: {
        redirectToList(route) {
            if (route !== router.currentRoute.name) {
                router.push({ name: route })
                    .catch(error => {
                        errorHandler(error)
                    })
            }
        },
    }
}
</script>
